import { CocoaAPI } from '../typings';

export type PlaybackModifier = {
  title: string;
  guid: string;
  url: string;
};

export function getPlaybackTitle(data: CocoaAPI.Playback): string {
  return 'metadata' in data ? data.metadata.title : data.title;
}

export function getPlaybackVideoId(data: CocoaAPI.Playback): string {
  return 'metadata' in data ? (data.metadata.guid ?? data.metadata.videoId) : data.videoId;
}

export function getPlaybackResumePoint(data: CocoaAPI.Playback): number {
  return 'metadata' in data ? data.metadata.resumePoint : data.resumePoint;
}

export function getPlaybackModifier(data: CocoaAPI.Playback): PlaybackModifier | null {
  if ('metadata' in data) {
    const modifier = data.modifiers?.[0];

    if (!modifier) {
      return null;
    }

    return {
      title: modifier.title,
      guid: modifier.guid ?? modifier.videoId,
      url: modifier.url,
    };
  }

  const modifier = data.modifier;

  if (!modifier) {
    return null;
  }

  return {
    title: modifier.title,
    guid: modifier.videoId,
    url: modifier.url,
  };
}
